import React from 'react';
import {formatNumberToCurrency} from '../../../../helpers/formatNumberToCurrency';
import {infoGrey, infoRed} from '../../../../assets/images/images';
import {useSelector} from 'react-redux';

export const AmountInput = ({showPayment, amount, setAmount}) => {
  const {userDetails} = useSelector(state => state.auth);

  const vatRate = 0.075; // 7.5% VAT
  const vatAmount = +amount * vatRate;
  const totalAmount = Number(amount) + vatAmount;

  const isNaira = ['paystack', 'transfer'].includes(showPayment);
  const minAmount = isNaira ? 50000 : 50;
  const canProceed = Number(amount) >= minAmount;

  const currency = userDetails?.company?.currency;

  return (
    <div className="py-4 px-6">
      <label htmlFor="topup_amount">
        <span className="text-sm ">Enter amount</span>
        <input
          placeholder={formatNumberToCurrency(
            userDetails?.company?.wallet_balance / 100 ?? 0,
            currency,
          )}
          className="mt-1.5"
          id="amount"
          value={amount}
          type="number"
          onChange={e => {
            setAmount(e.target.value);
          }}
        />
      </label>

      <div className="flex items-center gap-1 mt-2">
        <img
          src={amount && canProceed ? infoGrey : infoRed}
          alt=""
          width={16}
        />
        <p
          className={`${
            amount && canProceed ? 'text-grey-500' : 'text-status-404'
          } text-sm`}
        >
          The minimum top-up amount is{' '}
          {formatNumberToCurrency(minAmount, currency)}{isNaira ? ' (Excl. VAT)' : ''}
        </p>
      </div>

      {isNaira && (
        <div className="mt-5">
          <div className="py-3 flex items-center justify-between w-full">
            <p className="text-sm text-[#5C688E] font-medium"> 7.5% VAT: </p>
            <p className="text-sm font-semibold text-deepBlue">
              {formatNumberToCurrency(vatAmount, currency)}
            </p>
          </div>
          <div className="py-3 flex items-center justify-between w-full">
            <p className="text-sm text-[#5C688E] font-medium">Total amount:</p>
            <p className="text-sm font-semibold text-deepBlue">
              {formatNumberToCurrency(totalAmount, currency)} (VAT included)
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
